import { CustomBox } from "components/Box/CustomBox";
import React from "react";
import DescriptionIcon from "@material-ui/icons/Description";
import { fontSize, iconStyle } from "../CustomerView";
import RegularButton from "components/CustomButtons/Button";
import { useSelector } from "react-redux";
import { useHandleView } from "../useHandleView";

export const CustomerConditions = () => {
  const { customerConditions } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  const selectView = useHandleView(5);

  const handleNewCondition = () => {
    selectView();
  };
  return (
    <CustomBox
      title="Condiciones Mayoristas"
      count={customerConditions?.conditions.length}
      icon={<DescriptionIcon style={iconStyle} />}
      bg={<DescriptionIcon style={{ ...iconStyle, fontSize }} />}
    >
      <RegularButton
        size="sm"
        color="info"
        fullWidth
        onClick={handleNewCondition}
      >
        Ver
      </RegularButton>
    </CustomBox>
  );
};
